module.exports = __webpack_public_path__ + "static/feature-2-a879796c0e034f2fa4788f558b2bd44a.svg";